module.exports = "<a>\n    <div>\n        <span ng-bind-html=\"match.model.name | uibTypeaheadHighlight:query\"></span>\n        <span>({{match.model.code}})</span>\n    </div>\n    <!--<div class=\"text-muted\" ng-bind-html=\"match.model.countryName | uibTypeaheadHighlight:query\"></div>-->\n</a>\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/client/app/shared/institution/selector/institution-selector-item.html
// module id = 346
// module chunks = 0